import axios from 'axios';
import auth from "@/services/authService"
import EventBus from "@/services/eventBusService"

axios.interceptors.request.use(async (config) => {
  const token = await auth.getToken()
  config.headers.Authorization = `Bearer ${token}`
  config.withCredentials = true
  return config;
}, function(error) {
  // Do something with request error
  return Promise.reject(error);
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (!error.response) {
      EventBus.$emit('network-error', true)
    } else
    if (error.response.status === 401) {
      auth.logout();
      //router.push('/login');
    }
    return Promise.reject(error.data);
  }
);

export default axios
